import { render, staticRenderFns } from "./career-services.vue?vue&type=template&id=a3f4d40a&scoped=true&"
import script from "./career-services.vue?vue&type=script&lang=js&"
export * from "./career-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f4d40a",
  null
  
)

export default component.exports